import { __decorate, __metadata } from "tslib";
import { VuexModule, Module, Mutation, Action, getModule } from "vuex-module-decorators";
import store from "../../store";
import service from "../../services/api.service";
import * as _ from "lodash";
import { plainToClass } from "class-transformer";
import { getTenantId } from "@/store/helper";
//List
import { UserGridViewModel } from "../../store/models/users/user";
import { UserModel } from "../models/users/addUser";
import { UserDetailViewModel } from "../models/users/userDetailView";
import { GridOptionModel, IGridOption } from "../models/shared/gridOption";
let UserModule = /** @class */ (() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    let UserModule = class UserModule extends VuexModule {
        constructor() {
            super(...arguments);
            this.users = [];
            this.apiNode = "User";
            this.user = null;
            this.roles = [];
            this.userRoles = [];
            this.organizations = [];
            this.searchParams = null;
        }
        //Actions
        //List
        async GetAllUsers(searchData) {
            var url = `${getTenantId()}/${this.apiNode}`;
            let { data } = await service.post(url, searchData);
            if (data) {
                this.ListUsers(plainToClass(UserGridViewModel, data.users));
                return data;
            }
        }
        //Mutations
        ListUsers(User) {
            this.users = User;
        }
        async AddUserDefaults() {
            var url = `${getTenantId()}/${this.apiNode}/add/defaults`;
            let { data } = await service.get(url);
            if (data) {
                this.SetOrganizations(data.organizations);
                this.SetRoles(data.roles);
            }
            return data;
        }
        async GetRoles() {
            var url = `${getTenantId()}/${this.apiNode}/roles`;
            let { data } = await service.get(url);
            if (data) {
                this.SetDetail(data);
            }
            return data;
        }
        SetDetail(data) {
            this.userRoles = data.userRoles;
        }
        SetOrganizations(organizations) {
            this.organizations = organizations;
        }
        //Add
        async SaveUser(user) {
            var url = `${getTenantId()}/${this.apiNode}/add`;
            let { data } = await service.post(url, user);
            return data;
        }
        //View
        async ViewUser(userId) {
            var url = `${getTenantId()}/${this.apiNode}/view/` + userId;
            let { data } = await service.get(url);
            if (data) {
                this.ViewUsers(plainToClass(UserDetailViewModel, data.user));
                return data;
            }
        }
        //Mutations
        ViewUsers(user) {
            this.user = user;
        }
        //Update
        async GetUserDetailById(userId) {
            var url = `${getTenantId()}/${this.apiNode}/edit/` + userId;
            let { data } = await service.get(url);
            if (data) {
                this.EditUser(plainToClass(UserDetailViewModel, data.user));
                this.SetRoles(data.roles);
                this.SetOrganizations(data.organizations);
                return data;
            }
        }
        async DeleteUser(userId) {
            var url = `${getTenantId()}/${this.apiNode}/delete/` + userId;
            let { data } = await service.delete(url);
            return data;
        }
        SetRoles(roles) {
            this.roles = roles;
        }
        EditUser(user) {
            this.user = user;
        }
        async UpdateUser(updateUser) {
            var url = `${getTenantId()}/${this.apiNode}/update`;
            let { data } = await service.put(url, updateUser);
            return data;
        }
        AssignSearchParams(params) {
            this.searchParams = _.cloneDeep(params);
        }
        ClearSearchParams() {
            this.searchParams = null;
        }
    };
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_a = typeof IGridOption !== "undefined" && IGridOption) === "function" ? _a : Object]),
        __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
    ], UserModule.prototype, "GetAllUsers", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "ListUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
    ], UserModule.prototype, "AddUserDefaults", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
    ], UserModule.prototype, "GetRoles", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "SetDetail", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "SetOrganizations", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof UserModel !== "undefined" && UserModel) === "function" ? _e : Object]),
        __metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
    ], UserModule.prototype, "SaveUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_g = typeof Promise !== "undefined" && Promise) === "function" ? _g : Object)
    ], UserModule.prototype, "ViewUser", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_h = typeof UserDetailViewModel !== "undefined" && UserDetailViewModel) === "function" ? _h : Object]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "ViewUsers", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
    ], UserModule.prototype, "GetUserDetailById", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", typeof (_k = typeof Promise !== "undefined" && Promise) === "function" ? _k : Object)
    ], UserModule.prototype, "DeleteUser", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "SetRoles", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_l = typeof UserDetailViewModel !== "undefined" && UserDetailViewModel) === "function" ? _l : Object]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "EditUser", null);
    __decorate([
        Action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_m = typeof UserDetailViewModel !== "undefined" && UserDetailViewModel) === "function" ? _m : Object]),
        __metadata("design:returntype", Promise)
    ], UserModule.prototype, "UpdateUser", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_o = typeof GridOptionModel !== "undefined" && GridOptionModel) === "function" ? _o : Object]),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "AssignSearchParams", null);
    __decorate([
        Mutation,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UserModule.prototype, "ClearSearchParams", null);
    UserModule = __decorate([
        Module({ dynamic: true, store: store, name: "users", namespaced: true })
    ], UserModule);
    return UserModule;
})();
export default getModule(UserModule);
